
const TypeDacces=[
  { value: "1", label: "Ascenseur" },
  { value: "2", label: "Escalier" },
];


export default TypeDacces;
